import {constant} from 'lodash/fp';

import {ENABLE_TESTING_OPTIONS} from '/config/testingOptions.config';
import {FETCH_TESTING_OPTIONS} from '/enum/launchSequence.enum';
import {getTestingOptions} from '/redux/action/testingOptions.action';
import {completedStepByName} from '/redux/selector/launchSequence.selector';
import {withProps} from '/util/selector.util';

const fetchTestingOptionsTask = {
  stepName: FETCH_TESTING_OPTIONS,
  isCompleted: ({state}: any) =>
    // @ts-expect-error TS(2554): Expected 2 arguments, but got 1.
    withProps({stepName: FETCH_TESTING_OPTIONS})(completedStepByName)(state),
  perform: ({dispatch}: any) => {
    if (!ENABLE_TESTING_OPTIONS) {
      return Promise.resolve();
    }

    // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
    return dispatch(getTestingOptions()).catch(constant(undefined));
  },
};

export default fetchTestingOptionsTask;
